import { Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';

import { ApiError, MessageService, Task, TaskService } from '../../../../core';
import { IntegrationCliente } from './integration-cliente';
import { IntegrationPeriodicidade, periodicidadeDiaria, isPeriodicidadeDiaria, periodicidadeSemanal, isPeriodicidadeSemanal, periodicidadeMensal, isPeriodicidadeMensal, periodicidadeAnual, isPeriodicidadeAnual, periodicidadeGeral, isPeriodicidadeGeral } from '../integration-periodicidade';
import { IntegrationClienteHttpService } from './services';

@Component({
    selector: 'sgt-integration-cliente-modal',
    templateUrl: './integration-cliente-modal.component.html',
    styleUrls: ['./integration-cliente-modal.component.less']
})
export class IntegrationClienteModalComponent implements OnInit {
    entity = new IntegrationCliente();
    elModal: any;
    @Output() afterExecuteIntegration = new EventEmitter<any>();

    @ViewChild('form') form: NgForm;
    periodicidades: IntegrationPeriodicidade[] = [
        periodicidadeDiaria,
        periodicidadeSemanal,
        periodicidadeMensal,
        periodicidadeAnual,
        periodicidadeGeral
    ];

    constructor(private el: ElementRef,
                private messageService: MessageService,
                private taskService: TaskService,
                private integrationClienteHttpService: IntegrationClienteHttpService) { }

    ngOnInit() {
        this.create();
    }

    /** Cria o modal */
    private create() {
        this.elModal = jQuery(this.el.nativeElement).find('.modal') as any;
        this.elModal
            .on('show.bs.modal', (e: any) => {
                e.stopPropagation();
            })
            .on('shown.bs.modal', (e: any) => {
                jQuery(this.elModal).find('#integrationClientePeriodicidade').trigger('focus');
                e.stopPropagation();
            })
            .on('hide.bs.modal', (e: any) => {
                e.stopPropagation();
            })
            .on('hidden.bs.modal', (e: any) => {
                e.stopPropagation();
            });
    }

    private clear() {
        // this.form.resetForm();
        this.entity.clear();
    }

    open() {
        this.clear();

        this.elModal.modal({keyboard: false});
    }

    close() {
        this.elModal.modal('hide');
    }

    private beforeExecute() {
        if (!this.isPeriodicidadeGeral()) {
            this.entity.dataCadastroBase = null;
        }
    }

    /** Executa a integração de leitura dos clientes com os sistemas ERP's */
    execute() {
        if (this.form.valid) {
            this.beforeExecute();

            const task = new Task('Sincronizando clientes com o ERP', 'Executando sincronização dos clientes com o sistema ERP');
            this.taskService.add(task, task.description);
            this.integrationClienteHttpService.execReadIntegration(this.entity)
                .subscribe(
                    () => {
                        this.taskService.success(task, 'Sincronização dos clientes com o sistema ERP realizada com sucesso');
                        this.afterExecuteIntegration.emit();
                    },
                    (error: ApiError) => this.taskService.error(task, 'Erro ao realizar a sincronização dos clientes com o sistema ERP', error.message, error)
                );

            this.close();
        } else {
            this.messageService.info('Informe todos os campos corretamente para executar a sincronização dos clientes com o ERP', 'Informação');
        }
    }

    /** Verifica se a periodicidade selecionada é geral */
    isPeriodicidadeGeral(): boolean {
        if (!this.entity) {
            return false;
        }
        return isPeriodicidadeGeral(this.entity.periodicidade);
    }

    getDescricaoPeriodicidade(periodicidade: number): string {
        if (isPeriodicidadeDiaria(periodicidade)) {
            return 'Diária - Clientes cadastrados nas últimas 24 horas';
        } else if (isPeriodicidadeSemanal(periodicidade)) {
            return 'Semanal - Clientes cadastrados nos últimos 7 dias';
        } else if (isPeriodicidadeMensal(periodicidade)) {
            return 'Mensal - Clientes cadastrados a partir do mês anterior';
        } else if (isPeriodicidadeAnual(periodicidade)) {
            return 'Anual - Clientes cadastrados a partir do ano anterior';
        } else if (isPeriodicidadeGeral(periodicidade)) {
            return 'Geral - Clientes cadastrados a partir de uma data específica'
        }
        return '';
    }
}
